import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ShapeCreatorService {

  startShapeCreationEditor(): void {
    // To be implemented by subclasses
  }

  startShapeEditEditor(): void {
    // To be implemented by subclasses
  }

  stopShapeEditor(): void {
    // To be implemented by subclasses
  }

  getCurrentShape(): any {
    // To be implemented by   return undefined;
  }
}